import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFolder,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";
import "./index.scss";
import '../../../../assets/css/common/document/statusIcon.scss';
import ReactTooltip from 'react-tooltip';
import { sampleCSVData } from "../../../../utils/constants";
// import { CSVDownload, CSVLink } from "react-csv";

const DocMenus = ({ list, _handleSelectedAction, __sidebarActivePacketIndex }) => {
	const __handleSelectedAction = (index, id) => {
		console.log(
			'22',id
		);
		_handleSelectedAction(id, index);
		//setActiveId(index)
	};

	// let activeId = __sidebarActivePacketIndex && __sidebarActivePacketIndex !== undefined ? __sidebarActivePacketIndex : ''
	let activeId = __sidebarActivePacketIndex !== null ? __sidebarActivePacketIndex : null
	//   const [tooltipOpen, setTooltipOpen] = useState(false);
	//const [activeId, setActiveId] = useState(0);
	//   const toggle = () => setTooltipOpen(!tooltipOpen);
	return (
		<>
		<ul className="list-unstyled doc-list">
			{list.length  &&
				list.map((_val, index) => {

					return (
						<li className={activeId === index ? `active` : ``} key={`doc_${index}`} data-placement="top" >
							<Button
								color="link"
								className="text-start d-inline-flex align-items-center"
								onClick={() => __handleSelectedAction(index, _val._id)}
							>
								<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
									<FontAwesomeIcon icon={faFolder} />
								</span>
								<label>
									<span className="user-lbl d-block" data-tip={_val?.name}>{_val?.name}</span>
									{_val?.type?.type} {"30 Yr"} <br />
									<span data-tip={_val?.loan_number}> {_val?.loan_number}</span>
								</label>
								<span className="status-icon ms-auto">
									<span className="icon-cell d-inline-flex">
										<span className={`${_val.is_verified === 1 ? 'text-success' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center`}>
											{/* <CSVLink
												data={sampleCSVData}
												filename={"DemoOutputCSV.csv"}
												target="_blank"
												className={"remove-text-decoration"}
											> */}
											v
											{/* </CSVLink> */}
										</span>
									</span>

									 {/* <span className="icon-cell d-inline-flex">
										<span className={`${_val.is_correct === 1 ? 'text-success' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center`}>
											c
										</span>
									</span> */}
								</span>
							</Button>
						</li>
					);
				})}
			<ReactTooltip />
		</ul>
		</>
		// <>



		// 	{/* below this is static part */}



		// 	<ul className="list-unstyled doc-list">
		// 		<li data-placement="top" >
		// 			<Button
		// 				color="link"
		// 				className="text-start d-inline-flex align-items-center"
		// 			// onClick={() => __handleSelectedAction(index, _val._id)}
		// 			>
		// 				<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
		// 					<FontAwesomeIcon icon={faFolder} />
		// 				</span>
		// 				<label>
		// 					<span className="user-lbl d-block">Jonathan Trained</span>
		// 					Conv 30 Yr <br />
		// 					<span>1666810832437</span>
		// 				</label>
		// 				<span className="status-icon ms-auto">
		// 					<span className="icon-cell d-inline-flex">
		// 						<span className={'text-success icon flex-fill d-inline-flex align-items-center justify-content-center'}>
		// 							{/* <CSVLink
		// 										data={sampleCSVData}
		// 										filename={"DemoOutputCSV.csv"}
		// 										target="_blank"
		// 										className={"remove-text-decoration"}
		// 									> */}
		// 							v
		// 							{/* </CSVLink> */}
		// 						</span>
		// 					</span>

		// 					{/* <span className="icon-cell d-inline-flex">
		// 								<span className={`${_val.is_correct === 1 ? 'text-success' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center`}>
		// 									c
		// 								</span>
		// 							</span> */}
		// 				</span>
		// 			</Button>
		// 		</li>
		// 		<li data-placement="top" >
		// 			<Button
		// 				color="link"
		// 				className="text-start d-inline-flex align-items-center"
		// 			// onClick={() => __handleSelectedAction(index, _val._id)}
		// 			>
		// 				<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
		// 					<FontAwesomeIcon icon={faFolder} />
		// 				</span>
		// 				<label>
		// 					<span className="user-lbl d-block">Kyle Homebuyer</span>
		// 					FHA 30 Yr <br />
		// 					<span>1668715772181</span>
		// 				</label>
		// 				<span className="status-icon ms-auto">
		// 					<span className="icon-cell d-inline-flex">
		// 						<span className={'text-success icon flex-fill d-inline-flex align-items-center justify-content-center'}>
		// 							{/* <CSVLink
		// 										data={sampleCSVData}
		// 										filename={"DemoOutputCSV.csv"}
		// 										target="_blank"
		// 										className={"remove-text-decoration"}
		// 									> */}
		// 							v
		// 							{/* </CSVLink> */}
		// 						</span>
		// 					</span>

		// 					{/* <span className="icon-cell d-inline-flex">
		// 								<span className={`${_val.is_correct === 1 ? 'text-success' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center`}>
		// 									c
		// 								</span>
		// 							</span> */}
		// 				</span>
		// 			</Button>
		// 		</li>
		// 		<li data-placement="top" >
		// 			<Button
		// 				color="link"
		// 				className="text-start d-inline-flex align-items-center"
		// 			// onClick={() => __handleSelectedAction(index, _val._id)}
		// 			>
		// 				<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
		// 					<FontAwesomeIcon icon={faFolder} />
		// 				</span>
		// 				<label>
		// 					<span className="user-lbl d-block">David Auto</span>
		// 					VA 30 Yr <br />
		// 					<span>1668716244090</span>
		// 				</label>
		// 				<span className="status-icon ms-auto">
		// 					<span className="icon-cell d-inline-flex">
		// 						<span className={'text-success icon flex-fill d-inline-flex align-items-center justify-content-center'}>
		// 							{/* <CSVLink
		// 										data={sampleCSVData}
		// 										filename={"DemoOutputCSV.csv"}
		// 										target="_blank"
		// 										className={"remove-text-decoration"}
		// 									> */}
		// 							v
		// 							{/* </CSVLink> */}
		// 						</span>
		// 					</span>

		// 					{/* <span className="icon-cell d-inline-flex">
		// 								<span className={`${_val.is_correct === 1 ? 'text-success' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center`}>
		// 									c
		// 								</span>
		// 							</span> */}
		// 				</span>
		// 			</Button>
		// 		</li>

		// 		<ReactTooltip />
		// 	</ul>
		// </>
	);
};

export default DocMenus;
